document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-kaamo-before-after]').forEach(function (root) {
    var handle = root.querySelector('[data-kaamo-handle]');
    var afterClip = root.querySelector('[data-kaamo-after-clip]');
    if (!handle || !afterClip) return;

    var dragging = false;

    function setPosition(clientX) {
      var rect = root.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      handle.style.left = pct + '%';
      afterClip.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
    }

    function onMove(e) {
      if (!dragging) return;
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setPosition(clientX);
    }

    function start(e) {
      dragging = true;
      onMove(e);
    }

    function stop() {
      dragging = false;
    }

    handle.addEventListener('mousedown', start);
    root.addEventListener('mousedown', start);
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', stop);

    handle.addEventListener('touchstart', start, { passive: true });
    root.addEventListener('touchstart', start, { passive: true });
    window.addEventListener('touchmove', onMove, { passive: true });
    window.addEventListener('touchend', stop);
  });
});
